import React,{ useEffect, useMemo, useState } from 'react';
import useWrapWithLoader from '../../../hooks/useWrapWithLoading';
import useContentMgmt from '../../../hooks/useContentMgmt';
import microcopyGroupIds from '../../../components/pge-plus-common/microcopyGroupIds';
import { useMutation } from '@apollo/react-hooks';
import { approveInvoicePortalUserRegistrationMutation } from '../../../hooks/invoice-payment-portal/useInvoicePaymentRegistration';
import { InvoicePortalApproveUserRegistrationResponse, InvoicePortalRejectUserRegistrationResponse, RegisterInvoicePortalUserErrorReason } from '../../../__generated__/pge-types';
import { Card, CardContent, styled, Typography } from '@material-ui/core';
import queryString from 'query-string';

const PREFIX = 'Login';

const classes = {
  card: `${PREFIX}-card`,
  cardContent: `${PREFIX}-cardContent`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.card}`]: {
    padding: '4em 5em',
    [theme.breakpoints.down('sm')]: {
      padding: '4em 2em',
    },
  },
  [`& .${classes.cardContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
}));

const RegisterationSuccess = () => {
  const [registerationApproved, setRegisterationApproved] =
    useState<boolean>(false);
  const [registerationError, setRegisterationError] = useState<boolean>(false);
  const [isEmailAlreadyRegistered, setIsEmailAlreadyRegistered] =
    useState<boolean>(false);
  const { wrapWithLoader } = useWrapWithLoader();

  const { content } = useContentMgmt(microcopyGroupIds.INVOICE_PAYMENT_SIGN_IN);

  const queryParams = useMemo(() => {
      if (typeof window === 'undefined') {
        return {};
      }
      return queryString.parse(window.location.search);
    }, [typeof window !== 'undefined' ? window.location.search : '']);
   

  const [approveInvoicePortalUserRegistration] = useMutation<{
    approveInvoicePortalUserRegistration: InvoicePortalApproveUserRegistrationResponse;
  }>(approveInvoicePortalUserRegistrationMutation);

  useEffect(() => {
    const approveRegisteration = wrapWithLoader(async () => {
      try {
        const { data: registerData } = await approveInvoicePortalUserRegistration({
          variables: {
            payload: {
              token: decodeURIComponent(queryParams?.token as string),
            },
          },
        });
        if (registerData?.approveInvoicePortalUserRegistration?.isSuccess) {
          setRegisterationApproved(true);
          setRegisterationError(false);
        } else if (
          registerData?.approveInvoicePortalUserRegistration?.errorReason ===
          RegisterInvoicePortalUserErrorReason.EmailAlreadyRegistered
        ) {
          setRegisterationError(true);
          setIsEmailAlreadyRegistered(true);
          setRegisterationApproved(false);
        } else {
          setRegisterationError(true);
          setIsEmailAlreadyRegistered(false);
          setRegisterationApproved(false);
        }
        window.scrollTo(0, 0);
      } catch (e) {
        setRegisterationError(true);
        setIsEmailAlreadyRegistered(false);
        setRegisterationApproved(false);
      }
    });
    if (queryParams?.token) {
      void approveRegisteration();
    }
  }, [queryParams?.token]);
  return (
    <Root>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          {registerationApproved && (
            <>
              <Typography variant={'h1'}>
                {content.get('REGISTRATION_APPROVED')}
              </Typography>
              <Typography variant={'body1'}>
                {content.get('INVOICE_PAYMENT_USER_REGISTRATION_APPROVED')}
              </Typography>
            </>
          )}
          {registerationError && (
            <>
              <Typography variant={'h1'}>
                {content.get('REGISTRATION_FAILED')}
              </Typography>
              <Typography variant={'body1'}>
                {isEmailAlreadyRegistered
                  ? content.get('EMAIL_ALREADY_REGISTERED')
                  : content.get('GENERIC_ERROR_NOTIFICATION_MESSAGE')}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Root>
  );
};
export default RegisterationSuccess;
